import React from 'react';
import { withRouter } from 'react-router-dom';
import PageHOC from '../layout/PageHOC';
import DataSource from '../DataSource';
import Module from '../modules/Module';
import PlainText from "../components/PlainText";

class ThreeGPolicy extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
            title: '',
            description: '',
            sections: { title: '', items: [] },
            faqs: { title: '', items: [] }
        };
    }

    componentDidMount() {
        DataSource.getData('/api/getContent/pages/3gpolicy', response => {
            this.setState({...response}, this.props.animateInCompany);
        });
    }

    render() {
        return (
            <div>
                <Module className="row py-5 bg-lightgrey">
                    <div className="col-12 col-lg-6 offset-lg-3 text-center">
                        <h1 className="mt-0 mb-3">{this.state.title}</h1>
                        <p>{this.state.description}</p>
                    </div>
                </Module>

                <Module className="row bg-white py-5">
                    <div className="col-12 col-lg-6 offset-lg-3">
                        <h3 className="text-center bold">{this.state.sections.title}</h3>
                        {this.state.sections.items.map((item, key) => {
                            return (
                                <div key={key}>
                                    <h5 className="font-medium bold">{item.title}</h5>
                                    <PlainText key={key} data={item.data} excludeTitle={true} />
                                </div>
                            )
                        })}
                    </div>
                </Module>

                <Module className="row bg-white py-5">
                    <div className="col-12 col-lg-6 offset-lg-3">
                        <h3 className="bold">{this.state.faqs.title}</h3>
                        {this.state.faqs.items.map((item, key) => {
                            return (
                                <div key={key}>
                                    <h5 className="font-medium bold">{item.title}</h5>
                                    <PlainText key={key} data={item.data} excludeTitle={true} />
                                </div>
                            )
                        })}
                    </div>
                </Module>
            </div>
        );
    }

}

export default PageHOC(withRouter(ThreeGPolicy), '3G_POLICY_PAGE', true);



// WEBPACK FOOTER //
// ./resources/js/mobile/ThreeGPolicy.js